/**
 * Result holds the test status
 */
export default class Result {
    constructor() {
        this.status = '';
        this.statusLabel = '';
        this.throughput = 0;        //max th / Kbps
        this.direction = '';
        this.isFinished = false;
        this.info = '';
        this.latency = '';          //ms
        this.average = '';          //kbps
        this.restrans = 0.0;        //%
        this.jitter = 0;            //ms
        this.chartLink= '';
        this.chartLinkArray = [];
        this.mos = 0;
        this.module = 0;
        this.scoringType = '';
        this.rca1 = '';

        // 0: shooter, 1: flashtest, 2: packetloss
        this.testType = -1;
    }

    setStatus(status) {
        this.status = status;
        if (status === "SUCCESS" || status == "FAILED") {
            this.isFinished = true;
        }
    }

    setThroughput(throughput) {
        this.throughput = throughput;
    }


    setMos(mos) {
        this.mos = mos;
    }

    setScoringType(scoringType) {
        this.scoringType = scoringType;
    }

    setDirection(direction) {
        this.direction = direction;
    }

    setInfo(info) {
        this.info = info;
    }

    setStatusLabel(label) {
        this.statusLabel = label;
    }

    setAverage(average) {
        this.average = average;
    }

    setLatency(latency) {
        this.latency = latency;
    }

    setRetrans(retrans) {
        if (retrans && !isNaN(retrans)) {
            this.retrans = (retrans * 1).toFixed(5);
        } else {
            this.retrans = retrans;
        }
    }

    setJitter(jitter) {
        this.jitter = jitter;
    }

    setChartLink(link) {
        this.chartLink = link;
    }

    setChartLinkArray(nbSockets = 0) {
        if (nbSockets > 1) {
            for (var i = 0 ; i < nbSockets ; i++) {
                this.chartLinkArray.push({url:this.chartLink + "-" + i, index:i});
            }
        }
    }

    setTestType(type) {
        this.testType = type;
    }

    setModule(module) {
        this.module = module;
    }

    setMinLatency(minLatency) {
        this.minLatency = minLatency;
    }

    setRca1(rca1) {
        this.rca1 = rca1;
    }
}



// WEBPACK FOOTER //
// ./src/equalone-ui/components/results/Result.js